import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { sa } from '../superAdminUi';

// A section card for the group/school create and edit wizards, on the shared Super Admin
// design system: a white surface with a hairline border, soft radius and calm padding around
// one field group, with an optional leading (teal) icon and a right-aligned action beside the
// title. Purely presentational — it wraps children and owns no form state — so create and edit
// surfaces read the same. Sub-groupings inside a card still use FormSectionHeader for their
// divider-style headers.
export default function SectionCard({ title, subtitle, icon, action, children, sx }) {
  const hasHeader = Boolean(title || icon || action);

  return (
    <Box
      sx={{
        border: `1px solid ${sa.color.stroke}`,
        borderRadius: sa.radius.lg,
        p: { xs: 2, sm: 3 },
        bgcolor: sa.color.white,
        fontFamily: sa.font.family,
        ...sx,
      }}
    >
      {hasHeader && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: subtitle ? 0.5 : 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {icon && <Box sx={{ display: 'flex', color: sa.color.teal }}>{icon}</Box>}
            {title && (
              <Box
                component="span"
                sx={{
                  fontFamily: sa.font.family,
                  fontWeight: sa.font.bold,
                  fontSize: 16,
                  color: sa.color.text,
                }}
              >
                {title}
              </Box>
            )}
          </Box>
          {action}
        </Box>
      )}
      {subtitle && (
        <Box
          sx={{
            fontFamily: sa.font.family,
            fontSize: 13,
            color: sa.color.textGray,
            mb: 2,
          }}
        >
          {subtitle}
        </Box>
      )}
      {children}
    </Box>
  );
}

SectionCard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  icon: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
  sx: PropTypes.object,
};
